import { IIconProps } from '@fluentui/react';
import {
  MonthSelectorButtons,
  MonthSelectorTitle,
  MonthSelectorContainer,
} from '../styles/MonthSelector.styled';
import { EmployeeVacationDays } from '../../../../../tabs/models/SummaryInterfaces';
import { DECREMENT_MIN_MONTH, INCREMENT_MAX_MONTH } from 'src/tabs/constants/Timeoff.constants';

interface YearSelectorProps {
  year: number;
  month: string;
  incrementMonth: () => void;
  decrementMonth: () => void;
  vacationPeriodNextYear: EmployeeVacationDays;
  vacationPeriodPrevYear: EmployeeVacationDays;
}

export const MonthSelector = ({
  decrementMonth,
  incrementMonth,
  year,
  month,
  vacationPeriodNextYear,
  vacationPeriodPrevYear,
}: YearSelectorProps) => {
  const currentYear = new Date().getFullYear();
  const rightChevron: IIconProps = {
    iconName: 'ChevronRightSmall',
  };
  const leftChevron: IIconProps = {
    iconName: 'ChevronLeftSmall',
  };

  const incrementDisabled =
    !vacationPeriodNextYear && !(year < currentYear) && month === INCREMENT_MAX_MONTH;

  const decrementDisabled =
    !vacationPeriodPrevYear && !(year > currentYear) && month === DECREMENT_MIN_MONTH;
  return (
    <MonthSelectorContainer>
      <MonthSelectorButtons
        onClick={decrementMonth}
        iconProps={leftChevron}
        disabled={decrementDisabled}
      />
      <MonthSelectorTitle>
        {month} {year}
      </MonthSelectorTitle>
      <MonthSelectorButtons
        onClick={incrementMonth}
        iconProps={rightChevron}
        disabled={incrementDisabled}
      />
    </MonthSelectorContainer>
  );
};
